import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {ChevronDownSmall, ChevronUpSmall} from '@wix/wix-ui-icons-common/on-stage'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import s from '../ticket-details.scss'
import {TicketDetailsHeaderProps} from './interfaces'

export const TicketDetailsHeader = ({
  ticketIndex,
  ticketName,
  subtitle,
  editable,
  expanded,
  onExpand,
  details,
}: TicketDetailsHeaderProps) => {
  const {t} = useTranslation()

  return (
    <div className={s.header} onClick={editable ? onExpand : null}>
      <div className={s.title} aria-expanded={expanded} role="button" data-hook={DH.TICKET_DETAILS_HEADER_TITLE}>
        <div>
          {t('mobile.checkout.ticket.title', {
            index: ticketIndex + 1,
            name: ticketName,
            interpolation: {escapeValue: false},
          })}
        </div>
        {editable &&
          (expanded ? (
            <ChevronUpSmall className={s.arrow} aria-hidden={true} />
          ) : (
            <ChevronDownSmall className={s.arrow} aria-hidden={true} />
          ))}
      </div>
      {subtitle && <div className={s.ticketSubtitle}>{subtitle}</div>}
      {details && !expanded && (
        <div className={s.details}>
          <div>
            {details.firstName} {details.lastName}
          </div>
          <div>{details.email}</div>
        </div>
      )}
    </div>
  )
}
